export default function formatArrayToSearchParam(value: unknown) {
  return Array.isArray(value) ? value.join(',') : value;
}
